import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './Core_Appraisal_Report.css';

const Core_Appraisal_Report = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"CORE_APPRAISAL_REPORT",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	CORE_APPRAISAL_REPORT:-1
  });


  const [CORE_APPRAISAL_REPORT, setCORE_APPRAISAL_REPORT] = React.useState(null);
  const [CORE_APPRAISAL_REPORT_D, setCORE_APPRAISAL_REPORT_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Core Appraisal Report');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/Core_Appraisal_Report',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewCORE_APPRAISAL_REPORT(clientInfo,"OpenNew");

		navigate('/Core_Appraisal_Report',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Appraisal_Report_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(CORE_APPRAISAL_REPORT));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutCORE_APPRAISAL_REPORT(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostCORE_APPRAISAL_REPORT(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewCORE_APPRAISAL_REPORT(clientInfo,"OpenNew");
		}
		navigate('/Core_Appraisal_Report',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Appraisal_Report_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Appraisal_Report_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Appraisal_Report_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(CORE_APPRAISAL_REPORT));
		if(Temp_Data2.status!="New"){
			handleDeleteCORE_APPRAISAL_REPORT(Temp_Data2);
			navigate('/Core_Appraisal_Report#New',{replace:true});
		} 
		else 
			navigate('/Core_Appraisal_Report',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Appraisal_Report',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Appraisal_Report',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Appraisal_Report',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Appraisal_Report',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!CORE_APPRAISAL_REPORT) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_${i}_SECTION`;
	  const headerId = `#PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [CORE_APPRAISAL_REPORT]) ;


  
  
  var Ids = [];
  for(var Ele in CORE_APPRAISAL_REPORT){
	  for(var Sec in CORE_APPRAISAL_REPORT[Ele]){
		if(Sec == "id")
			Ids.push(CORE_APPRAISAL_REPORT[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(CORE_APPRAISAL_REPORT[Ele]["status"]);
		else if(Array.isArray(CORE_APPRAISAL_REPORT[Ele][Sec]))
			  for(var Row in CORE_APPRAISAL_REPORT[Ele][Sec])  // Convert to CORE_APPRAISAL_REPORT[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in CORE_APPRAISAL_REPORT[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["CORE_APPRAISAL_REPORT"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewCORE_APPRAISAL_REPORT(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_APPRAISAL_REPORT`).then((response1) => {
		if(!CORE_APPRAISAL_REPORT) 
			setCORE_APPRAISAL_REPORT(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_APPRAISAL_REPORT_D`).then((response2) => {
			setCORE_APPRAISAL_REPORT_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddCORE_APPRAISAL_REPORT_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewCORE_APPRAISAL_REPORT = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_APPRAISAL_REPORT/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setCORE_APPRAISAL_REPORT(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataCORE_APPRAISAL_REPORT = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_APPRAISAL_REPORT/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutCORE_APPRAISAL_REPORT = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_APPRAISAL_REPORT/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostCORE_APPRAISAL_REPORT = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_APPRAISAL_REPORT', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteCORE_APPRAISAL_REPORT = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_APPRAISAL_REPORT', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_APPRAISAL_REPORT));
	Temp_Data["1"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_0"]=value;
	//handleAddCORE_APPRAISAL_REPORT(Temp_Data,App_Data['CORE_APPRAISAL_REPORT']);
	Form_Data_onChange("1","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_0",value,Temp_Data);
 	//handleLastDataCORE_APPRAISAL_REPORT(Temp_Data);
    setCORE_APPRAISAL_REPORT(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_APPRAISAL_REPORT));
	Temp_Data["1"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_1"]=value;
	//handleAddCORE_APPRAISAL_REPORT(Temp_Data,App_Data['CORE_APPRAISAL_REPORT']);
	Form_Data_onChange("1","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_1",value,Temp_Data);
 	//handleLastDataCORE_APPRAISAL_REPORT(Temp_Data);
    setCORE_APPRAISAL_REPORT(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_APPRAISAL_REPORT));
	Temp_Data["1"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_2"]=value;
	//handleAddCORE_APPRAISAL_REPORT(Temp_Data,App_Data['CORE_APPRAISAL_REPORT']);
	Form_Data_onChange("1","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_2",value,Temp_Data);
 	//handleLastDataCORE_APPRAISAL_REPORT(Temp_Data);
    setCORE_APPRAISAL_REPORT(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_APPRAISAL_REPORT));
	Temp_Data["1"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_3"]=value;
	Form_Data_onChange("1","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_3",value,Temp_Data);
    setCORE_APPRAISAL_REPORT(Temp_Data);
  }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_APPRAISAL_REPORT));
	Temp_Data["2"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_0"]=value;
	//handleAddCORE_APPRAISAL_REPORT(Temp_Data,App_Data['CORE_APPRAISAL_REPORT']);
	Form_Data_onChange("2","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_0",value,Temp_Data);
 	//handleLastDataCORE_APPRAISAL_REPORT(Temp_Data);
    setCORE_APPRAISAL_REPORT(Temp_Data);
 }; 
  

const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_APPRAISAL_REPORT));
	Temp_Data["2"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_1"]=value;
	Form_Data_onChange("2","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_1",value,Temp_Data);
 	//handleLastDataCORE_APPRAISAL_REPORT(Temp_Data);
    setCORE_APPRAISAL_REPORT(Temp_Data);
	//handleAddCORE_APPRAISAL_REPORT(Temp_Data,App_Data['CORE_APPRAISAL_REPORT']);
  }; 
  

    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_APPRAISAL_REPORT));
	Temp_Data["2"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_2"]=value;
	//handleAddCORE_APPRAISAL_REPORT(Temp_Data,App_Data['CORE_APPRAISAL_REPORT']);
	Form_Data_onChange("2","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_2",value,Temp_Data);
 	//handleLastDataCORE_APPRAISAL_REPORT(Temp_Data);
    setCORE_APPRAISAL_REPORT(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_APPRAISAL_REPORT));
	Temp_Data["2"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_3"]=value;
	//handleAddCORE_APPRAISAL_REPORT(Temp_Data,App_Data['CORE_APPRAISAL_REPORT']);
	Form_Data_onChange("2","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_3",value,Temp_Data);
 	//handleLastDataCORE_APPRAISAL_REPORT(Temp_Data);
    setCORE_APPRAISAL_REPORT(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_APPRAISAL_REPORT));
	Temp_Data["3"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_3_0"]=value;
	//handleAddCORE_APPRAISAL_REPORT(Temp_Data,App_Data['CORE_APPRAISAL_REPORT']);
	Form_Data_onChange("3","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_3_0",value,Temp_Data);
 	//handleLastDataCORE_APPRAISAL_REPORT(Temp_Data);
    setCORE_APPRAISAL_REPORT(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_APPRAISAL_REPORT));
	Temp_Data["4"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_4_0"]=value;
	//handleAddCORE_APPRAISAL_REPORT(Temp_Data,App_Data['CORE_APPRAISAL_REPORT']);
	Form_Data_onChange("4","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_4_0",value,Temp_Data);
 	//handleLastDataCORE_APPRAISAL_REPORT(Temp_Data);
    setCORE_APPRAISAL_REPORT(Temp_Data);
 }; 
  

const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_APPRAISAL_REPORT));
	Temp_Data["4"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_4_1"]=value;
	Form_Data_onChange("4","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_4_1",value,Temp_Data);
 	//handleLastDataCORE_APPRAISAL_REPORT(Temp_Data);
    setCORE_APPRAISAL_REPORT(Temp_Data);
	//handleAddCORE_APPRAISAL_REPORT(Temp_Data,App_Data['CORE_APPRAISAL_REPORT']);
  }; 
  


const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_APPRAISAL_REPORT));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_0"]=value;
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_0",value,Temp_Data);
 	//handleLastDataCORE_APPRAISAL_REPORT(Temp_Data);
    setCORE_APPRAISAL_REPORT(Temp_Data);
	//handleAddCORE_APPRAISAL_REPORT(Temp_Data,App_Data['CORE_APPRAISAL_REPORT']);
  }; 
  

    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_APPRAISAL_REPORT));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_1"]=value;
	//handleAddCORE_APPRAISAL_REPORT(Temp_Data,App_Data['CORE_APPRAISAL_REPORT']);
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_1",value,Temp_Data);
 	//handleLastDataCORE_APPRAISAL_REPORT(Temp_Data);
    setCORE_APPRAISAL_REPORT(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_APPRAISAL_REPORT));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_2"]=value;
	//handleAddCORE_APPRAISAL_REPORT(Temp_Data,App_Data['CORE_APPRAISAL_REPORT']);
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_2",value,Temp_Data);
 	//handleLastDataCORE_APPRAISAL_REPORT(Temp_Data);
    setCORE_APPRAISAL_REPORT(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_APPRAISAL_REPORT));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_3"]=value;
	//handleAddCORE_APPRAISAL_REPORT(Temp_Data,App_Data['CORE_APPRAISAL_REPORT']);
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_3",value,Temp_Data);
 	//handleLastDataCORE_APPRAISAL_REPORT(Temp_Data);
    setCORE_APPRAISAL_REPORT(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_APPRAISAL_REPORT));
	Temp_Data["9"]["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_4"]=value;
	//handleAddCORE_APPRAISAL_REPORT(Temp_Data,App_Data['CORE_APPRAISAL_REPORT']);
	Form_Data_onChange("9","PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_4",value,Temp_Data);
 	//handleLastDataCORE_APPRAISAL_REPORT(Temp_Data);
    setCORE_APPRAISAL_REPORT(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!CORE_APPRAISAL_REPORT) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedCORE_APPRAISAL_REPORT =JSON.parse(JSON.stringify(CORE_APPRAISAL_REPORT));
  updatedCORE_APPRAISAL_REPORT[Sec] = [...updatedCORE_APPRAISAL_REPORT[Sec], newRow];
  setCORE_APPRAISAL_REPORT(updatedCORE_APPRAISAL_REPORT);
};

const handleDeleteRow = (sec,index) => {
  const updatedCORE_APPRAISAL_REPORT = JSON.parse(JSON.stringify(CORE_APPRAISAL_REPORT));
  updatedCORE_APPRAISAL_REPORT[sec].splice(index, 1);
  setCORE_APPRAISAL_REPORT(updatedCORE_APPRAISAL_REPORT);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Core Appraisal Report`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Appraisal ID`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Appraisal ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_0" type="text" className="form-control" placeholder="Appraisal ID" value={CORE_APPRAISAL_REPORT["1"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_0`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Appraisal ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_1" type="text" className="form-control" placeholder="Asset ID" value={CORE_APPRAISAL_REPORT["1"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_1`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Appraiser ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_2" type="text" className="form-control" placeholder="Appraiser ID" value={CORE_APPRAISAL_REPORT["1"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_2`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Appraiser ID`)}
                     </div>
                  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Appraisal Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_3" type="date"  value={CORE_APPRAISAL_REPORT["1"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_3`]} 
							onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_3_Change} style={{ borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_1_3"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Appraisal Date
					  </div>
				  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Appraised Value USD`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Appraised Value USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_0" type="text" className="form-control" placeholder="Appraised Value USD" value={CORE_APPRAISAL_REPORT["2"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_0`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Appraised Value USD`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Valuation Method`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_1"  value={CORE_APPRAISAL_REPORT["2"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_1`]} onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_1_Change} className="form-control" name="Valuation Method"  >
						  <option value="Sales Comparison">Sales Comparison</option>
						  <option value="Income Approach">Income Approach</option>
						  <option value="Cost Approach">Cost Approach</option>
						  <option value="Broker Opinion">Broker Opinion</option>
						  <option value="AVM">AVM</option>
						  <option value="Hybrid">Hybrid</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Valuation Method
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Cap Rate`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_2" type="text" className="form-control" placeholder="Cap Rate" value={CORE_APPRAISAL_REPORT["2"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_2`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Cap Rate`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`NOI Used USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_3" type="text" className="form-control" placeholder="NOI Used USD" value={CORE_APPRAISAL_REPORT["2"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_3`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_2_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter NOI Used USD`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Comparable Count`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_3_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '50ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Comparable Count`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_3_0" type="text" className="form-control" placeholder="Comparable Count" value={CORE_APPRAISAL_REPORT["3"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_3_0`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '50ch' }}>
						 {t(`Enter Comparable Count`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Report Link`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_4_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Report Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_4_0" type="text" className="form-control" placeholder="Report Link" value={CORE_APPRAISAL_REPORT["4"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_4_0`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Report Link`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Reviewer Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_4_1"  value={CORE_APPRAISAL_REPORT["4"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_4_1`]} onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_4_1_Change} className="form-control" name="Reviewer Approval Status"  >
						  <option value="Not Reviewed">Not Reviewed</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Needs Revision">Needs Revision</option>
						  <option value="Second Review Required">Second Review Required</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Reviewer Approval Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_0"  value={CORE_APPRAISAL_REPORT["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_0`]} onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_1" type="text" className="form-control" placeholder="Created By" value={CORE_APPRAISAL_REPORT["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_1`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_2" type="text" className="form-control" placeholder="Created At" value={CORE_APPRAISAL_REPORT["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_2`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_3" type="text" className="form-control" placeholder="Updated By" value={CORE_APPRAISAL_REPORT["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_3`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_4" type="text" className="form-control" placeholder="Updated At" value={CORE_APPRAISAL_REPORT["9"][`PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_4`]} 
						onChange={PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_04_ASSET_SPV_DUE_DILIGENCE_LEGAL_CORE_APPRAISAL_REPORT_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default Core_Appraisal_Report;  